import * as auth from "../auth.js";

const baseUrl = window.appSettings.api.uri;
const getRootAPI = () => {
  if (process.env.NODE_ENV === "development") {
  return baseUrl;
  }
  // For production, you can add the production API root later
  return baseUrl;
};

const Tools = {
  formatNumber: (number) => {
    return number.toLocaleString();
  },
  sendRequest: async (resource, params) => {
    let queryString = '';
    console.log("Got request", resource, params)
    if (typeof params === 'object' && params !== null) {
      // If params is an object (dictionary), convert it to a query string
      queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    } else if (typeof params === 'string') {
      // If params is already a string, use it as is
      queryString = params;
    }

    const fullUrl = getRootAPI() + "/" + resource + (queryString ? `?${queryString}` : '');
    const options = {
      method: "GET",
      headers: {
        Authorization: await auth.getToken(),
      },
    };

    let response;
    console.debug("Request opts:", JSON.stringify(options, null, 4));
    response = await fetch(fullUrl, options);

    console.debug("Response:", response);

    let data = await response.json();

    // Process the data if the resource is 'get-data'
    if (resource === 'get-data') {
      const fieldsToConvert = [
        "agent_percent",
        "agent_performance_score",
        "agent_sentiment",
        "customer_experience_score",
        "customer_final_satisfaction",
        "customer_sentiment"
      ];

      if (Array.isArray(data.data)) {
        data.data = data.data.map(item => {
          fieldsToConvert.forEach(field => {
            if (item[field] !== null && item[field] !== undefined && item[field] !== '') {
              item[field] = parseFloat(item[field]);
            }
          });
          return item;
        });
      }
    }

    return data;
  },
  
};

export default Tools;
